import { expected, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { DEPRECIATION_SEGMENTS, DepreciationSegment, FEATURES } from '../../constants.ts';
import { selectImprovementsById } from './propertyDataSelectors/improvementsSelectors.ts';
import { selectOrderFeatures } from './selectOrderFeatures.ts';

export const selectDepreciationSegments = createSelector(
  [selectOrderFeatures, selectImprovementsById],
  (orderFeatures, improvements) => {
    if (isUndefined(orderFeatures) || isUndefined(improvements)) return [];

    return DEPRECIATION_SEGMENTS.reduce((acc: DepreciationSegment[], segment) => {
      if (segment.orderFeature && orderFeatures.includes(segment.orderFeature)) {
        const enabled = FEATURES[segment.orderFeature].hasFeature(expected(improvements));

        acc.push({ ...segment, enabled });
      }

      return acc;
    }, []);
  },
);
